import { AppointmentMode } from '__generated__/globalTypes';
import { IFormState } from './types';

const initialState: IFormState = {
  service: {} as IFormState['service'],
  step: 0,
  answers: {
    0: { email: '', phone: '' },
    1: {
      appointmentMode: AppointmentMode.PHONE,
      languages: [],
      timeZone: '',
    },
    2: { date: undefined },
    3: { counsellor: '' },
    4: { time: undefined },
  },
  details: {
    counsellor: null,
    phoneWithoutCallingCode: '',
    submittedForm: false,
  },
};

export default initialState;
